import {NgModule} from '@angular/core';
import {SearchFormComponent} from './search-form.component';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {DeviceStatusSelectComponent} from '../../inputs/device-status-select/device-status-select.component';
import {LocationStatusSelectComponent} from '../../inputs/location-status-select/location-status-select.component';
import {SortSelectComponent} from '../../inputs/sort-select/sort-select.component';
import {TextSearchComplexComponent} from '../../inputs/text-search-complex/text-search-complex.component';
import {InlineSelectComponent} from '../../inputs/base-select/inline-select/inline-select.component';
import {TextSearchSimpleComponent} from '../../inputs/text-search-simple/text-search-simple.component';
import {SimpleSortSelectComponent} from '../../inputs/simple-sort-select/simple-sort-select.component';
import {CategorySelectModule} from '../../inputs/category-select/category-select.module';
import {OwnershipSelectModule} from '../../inputs/ownership-select/ownership-select.module';
import {SimpleSelectModule} from '../../inputs/base-select/simple-select/simple-select.module';
import {DateInputModule} from '../../inputs/date-input/date-input.module';
import {DepartmentSelectModule} from '../../inputs/department-select/department-select.module';

@NgModule({
    imports: [
        PagesSharedModule,
        CategorySelectModule,
        SimpleSelectModule,
        OwnershipSelectModule,
        DateInputModule,
        DepartmentSelectModule
    ],
    declarations: [
        SearchFormComponent,
        TextSearchComplexComponent,
        TextSearchSimpleComponent,
        DeviceStatusSelectComponent,
        LocationStatusSelectComponent,
        SortSelectComponent,
        SimpleSortSelectComponent,
        InlineSelectComponent
    ],
    entryComponents: [],
    exports: [
        SearchFormComponent,
        TextSearchComplexComponent,
        TextSearchSimpleComponent,
        DeviceStatusSelectComponent,
        LocationStatusSelectComponent,
        SortSelectComponent,
        SimpleSortSelectComponent,
        InlineSelectComponent
    ]
})
export class SearchFormModule {
}
